module.exports = ".panel-body {\n  padding-top: 0px; }\n\n.panel-body img {\n  padding-left: 91px; }\n"